import { render, staticRenderFns } from "./InfoGrid.vue?vue&type=template&id=1a73388b"
import script from "./InfoGrid.vue?vue&type=script&lang=js"
export * from "./InfoGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports